const requiredMessage: { [key: string]: string } = {
  en: 'Required field',
  ru: 'Обязательное поле',
  uk: "Обов'язкове поле",
  ka: 'სავალდებულო ველი',
  tr: 'Zorunlu alan',
}

const emailMessage: { [key: string]: string } = {
  en: 'Email format is incorrect',
  uk: 'Неправильний формат електронної пошти',
  ru: 'Неверный формат электронной почты',
  ka: 'ელფოსტის ფორმატი არასწორია',
  tr: 'E-posta biçimi yanlış',
}

const phoneMessage: { [key: string]: string } = {
  en: 'Incorrect phone format',
  uk: 'Неправильний формат номеру телефону',
  ru: 'Неправильный формат телефонного номера',
  ka: 'ტელეფონის ნომრის არასწორი ფორმატი',
  tr: 'Yanlış telefon numarası biçimi',
}

const minLengthMessage: { [key: string]: string } = {
  en: 'Minimum 2 characters',
  uk: 'Мінімум 2 символи',
  ru: 'Минимум 2 символа',
  tr: 'Minimum 2 karakter',
  ka: 'მინიმუმ 2 სიმბოლო',
}

export const required = (lang: string) => {
  return requiredMessage[lang]
}

export const phonePattern = (lang: string) => {
  return {
    value: /^\+{3} \(\d{2}\) \d{3} \d{2} \d{2}$/,
    message: phoneMessage[lang],
  }
}

export const minLength2Pattern = (lang: string) => {
  return {
    value: /^.{2,}$/,
    message: minLengthMessage[lang],
  }
}

export const emailPattern = (lang: string) => {
  return {
    value:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: emailMessage[lang],
  }
}
